var map = {
	"./logo-alphabet.svg": 5126,
	"./logo-amazon-2.svg": 5127,
	"./logo-amazon.svg": 5128,
	"./logo-azercell.svg": 5129,
	"./logo-bank-of-america.svg": 5130,
	"./logo-barclays.svg": 5131,
	"./logo-bbc.svg": 5132,
	"./logo-bnp-paribas.svg": 5133,
	"./logo-booking.svg": 5134,
	"./logo-citibank.svg": 5135,
	"./logo-coca-cola.svg": 5136,
	"./logo-deloitte.svg": 5137,
	"./logo-experian.svg": 5138,
	"./logo-facebook.svg": 5139,
	"./logo-g.svg": 5140,
	"./logo-goldman-sachs.svg": 5141,
	"./logo-google.svg": 5142,
	"./logo-h.svg": 5143,
	"./logo-henkel.svg": 5144,
	"./logo-hsbc.svg": 5145,
	"./logo-ikea.svg": 5146,
	"./logo-infineon.svg": 5147,
	"./logo-instagram.svg": 5148,
	"./logo-jp-morgan.svg": 5149,
	"./logo-jti.svg": 5150,
	"./logo-linkedin.svg": 5151,
	"./logo-meta.svg": 5152,
	"./logo-morgan-stanley.svg": 5153,
	"./logo-netflix.svg": 5154,
	"./logo-oracle.svg": 5155,
	"./logo-paypal.svg": 5156,
	"./logo-pwc-new.svg": 5157,
	"./logo-pwc.svg": 5158,
	"./logo-spotify.svg": 5159,
	"./logo-tesla.svg": 5160,
	"./logo-visa.svg": 5161,
	"./logo-walmart.svg": 5162,
	"./logo-youtube.svg": 5163
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5125;